import React from "react";
import { Navigate, useLocation } from "@/lib/nav";
import { useAuth } from "@/context/AuthContext";
import { lockEnabled, sessionState, hasSealedBox } from "@/lib/weblock";

export default function ProtectedRoute({ children }) {
  const { isAuth, ready } = useAuth();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <span className="font-mono text-sm text-[#666]">Verifica identità…<span className="lt-cursor">_</span></span>
      </div>
    );
  }
  // AUDIT v3.1.0: col doppio PIN attivo, a scheda bloccata il token non c'è per scelta.
  // Qui si mostra il cancello del PIN (dentro la pagina), non la richiesta di accedere:
  // sarà il PIN reale a riaprire la cassetta e restituire identità e sessione.
  if (!isAuth && lockEnabled() && sessionState() !== "real" && hasSealedBox()) return children;
  if (!isAuth) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}
